import React from 'react';
import { Award, Languages, MapPin, CheckCircle } from 'lucide-react';
const EmployerSummary: React.FC = () => {
  return <section className="bg-white border-b border-sage-mint/20 py-8" data-id="element-315">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-316">
        <div className="bg-gradient-to-r from-sage-mint/5 to-coral-pink/5 rounded-xl p-6 md:p-8" data-id="element-317">
          {/* Employer-focused headline */}
          <div className="flex items-start mb-4" data-id="element-318">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage-mint/20 flex items-center justify-center mr-4" data-id="element-319">
              <Award className="h-6 w-6 text-sage-mint" data-id="element-320" />
            </div>
            <div className="flex-1" data-id="element-321">
              <h2 className="text-xl md:text-2xl font-medium text-charcoal mb-2" data-id="element-322">
                Finnish-Trained RN | Singapore-Ready | Immediate Availability
              </h2>
              <p className="text-grey-600 leading-relaxed" data-id="element-323">
                Registered Nurse with Finnish healthcare training and 20+
                verified Duodecim certifications, combining Nordic clinical
                precision with Southeast Asian cultural intelligence.
                Specialized in geriatric care (90% expertise), patient safety,
                and mental health. Trilingual (English, Thai, Finnish) with
                proven ability to deliver evidence-based care in multicultural
                settings. Currently based in Singapore and seeking immediate
                nursing opportunities.
              </p>
            </div>
          </div>
          {/* Key qualifications grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6" data-id="element-324">
            <div className="flex items-center bg-white rounded-lg p-3 shadow-sm" data-id="element-325">
              <CheckCircle className="h-5 w-5 text-sage-mint mr-2 flex-shrink-0" data-id="element-326" />
              <div data-id="element-327">
                <p className="text-xs text-grey-600" data-id="element-328">Eligibility</p>
                <p className="text-sm font-medium text-charcoal" data-id="element-329">
                  Singapore-Based
                </p>
              </div>
            </div>
            <div className="flex items-center bg-white rounded-lg p-3 shadow-sm" data-id="element-330">
              <CheckCircle className="h-5 w-5 text-sage-mint mr-2 flex-shrink-0" data-id="element-331" />
              <div data-id="element-332">
                <p className="text-xs text-grey-600" data-id="element-333">Experience</p>
                <p className="text-sm font-medium text-charcoal" data-id="element-334">
                  Geriatric & Psychiatric
                </p>
              </div>
            </div>
            <div className="flex items-center bg-white rounded-lg p-3 shadow-sm" data-id="element-335">
              <Languages className="h-5 w-5 text-sage-mint mr-2 flex-shrink-0" data-id="element-336" />
              <div data-id="element-337">
                <p className="text-xs text-grey-600" data-id="element-338">Languages</p>
                <p className="text-sm font-medium text-charcoal" data-id="element-339">EN, TH, FI</p>
              </div>
            </div>
            <div className="flex items-center bg-white rounded-lg p-3 shadow-sm" data-id="element-340">
              <MapPin className="h-5 w-5 text-sage-mint mr-2 flex-shrink-0" data-id="element-341" />
              <div data-id="element-342">
                <p className="text-xs text-grey-600" data-id="element-343">Availability</p>
                <p className="text-sm font-medium text-charcoal" data-id="element-344">Immediate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default EmployerSummary;